<template>
  <div v-if="doc.busyLoadingDetails">
    <b-icon icon="loading" size="is-small" custom-class="mdi-spin"></b-icon>
    Loading...
  </div>
  <div v-else-if="doc.errorLoadingDetails" class="no-data-error">
    <b-icon icon="google-downasaur" size="is-medium"></b-icon>
    Error loading details
  </div>
  <json-viewer
    v-else
    :value="doc.data"
    :expand-depth=2
    :expanded="true"
    copyable
    boxed
    sort/>
</template>

<script>
  import JsonViewer from 'vue-json-viewer'

  export default {
    name: "DocumentDetailsData",
    components: { JsonViewer },
    props: {
      doc: { type: Object, required: true }
    }
  }
</script>


<style>
  .no-data-error {
    opacity: 0.5;
  }
</style>
